<template>
  <div v-if="!pre_pay" :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  پرینت فاکتور پیش پرداخت 
                </div>
                <div>
                </div>
              </div>

              <div class="ar-card-body p-2">

                <div class="ar-form-group text-center">
                  <label class="text-center">
                    ابتدا حساب بانکی ارزینه را انتخاب نمایید.
                  </label>
                  <select @change="selectAdminBankAccount()" class="ar-form-control text-center" v-model="form.admin_bank_account_id">
                    <option :value="null" disabled hidden>انتخاب حساب بانکی ارزینه</option>
                    <option v-for="(item , key) in admin_bank_accounts" :key="key" :value="item.id">{{ item.card_name }}</option>
                  </select>
                </div>

                <div class="ar-form-group text-center">
                  <label class="text-center">
                    ولت مورد نظر خود را انتخاب نمایید.
                  </label>
                  <select class="ar-form-control text-center" v-model="form.wallet">
                    <option :value="null" disabled hidden>لطفا ولت خود را انتخاب نمایید</option>
                    <option v-for="(item , key) in state_wallets" :key="key" :value="item" class=" font-en">{{ item.address }}</option>
                  </select>
                </div>

                <div class="p-2">لطفا حساب (های) خود را به همراه مبلغ واریزی درج نمایید.</div>

                <div class="row" v-for="(item , key) in amounts" :key="key">
                  <div class="col-md-12 col-lg-4">
                    
                    <div class="ar-form-group text-center mb-0">
                      <select @change="selectAdminBankAccount()" class="ar-form-control text-center" v-model="item.user_bank_account">
                        <option :value="null" disabled hidden>انتخاب حساب بانکی</option>
                        <option v-for="(item , key) in state_bank_accounts" :key="key" :value="item">{{ item.card_number }}</option>
                      </select>
                      <div style="height:10px"></div>
                    </div>

                  </div>
                  <div class="col-md-12 col-lg-4">
                    <div class="ar-form-group mb-0">
                      <input type="number" class="ar-form-control text-center" placeholder="مبلغ" v-model="item.amount">
                    </div>
                    <div style="text-align:left;height:30px"><small v-if="item.amount">{{ formatPrice(item.amount) }} ریال</small></div>
                  </div>
                  <div class="col-md-12 col-lg-4">
                    <i @click="removeItem(key)" class="mdi mdi-trash-can-outline font-2 text-danger"></i>
                  </div>
                </div>

                <div class="d-flex justify-content-end">
                  <button @click="addItem()" class="ar-btn size-sm primary">افزودن <i class="mdi mdi-plus"></i></button>
                </div>

                <div class="d-flex justify-content-center mt-4">
                  <button @click="prepareInvoice()" class="ar-btn size-lg round primary">پرینت فاکتور</button>
                </div>

              </div>

              
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="p-2">

    <div class="prepay-wrapper font-titr" id="prepay">

      <img :src="StaticImageUrl+'assets/images/prepay-header.png'" class="prepay-header-logo">

      <div style="text-align: center;padding: .5rem 0;font-size: 1.25em;font-family: 'IRANSansBold';">صورتحساب فروش ارز دیجیتال</div>

      <div class="row py-2">
        <div class="col-4"></div>
        <div style="font-size:1.35em" class="col-4 text-center">
          ارزینه | افتخار پارسیان
        </div>
        <div class="col-4">

          <div class="flex-1">
            <div class="w-50">کد اقتصادی:</div>
            <div class="w-50">10380113428</div>
          </div>
          <div class="flex-1">
            <div class="w-50">تاریخ تراکنش:</div>
            <div class="w-50" >
              <template v-if="state_setting.date">{{ state_setting.date }}</template>
            </div>
          </div>
          <div class="flex-1">
            <div class="w-50">شماره سند:</div>
            <div class="w-50">973037</div>
          </div>

        </div>
      </div>

      <div class="holo"># {{ getTotal }} IRR</div>

      <div>* مشخصات خریدار</div>
      <div class="bold-border" style="font-size:.85em;padding:4px 8px">
        <div class="row">
          <div class="col-4">نام و نام خانوادگی : {{ userData.fullname }}</div>
          <div class="col-4">کد ملی : {{ userData.national_code }}</div>
          <div class="col-4">تلفن تماس : {{ userData.mobile_number }}</div>
        </div>
        <div class="row">
          <div class="col-12">نشانی: {{ userData.address }}</div>
        </div>
      </div>

      <div>* مشخصات واریز</div>
      <div class="thin-border tbl-wrapper">
        
        <table class="tbl">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>تاریخ</th>
              <th>شماره شبا مشتری</th>
              <th>شماره شبا ارزینه</th>
              <th>مبلغ تراکنش (ریال)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item , key) in deposit_details" :key="key">
              <td>{{ key + 1 }}</td>
              <td><template v-if="item.id">{{ state_setting.date }}</template></td>
              <td>
                <template v-if="item.user_bank && item.id">
                  <template v-if="item.user_bank.shaba_number">
                    {{ item.user_bank.shaba_number }}
                  </template>
                </template>
              </td>
              <td><template v-if="item.id">{{ admin_bank_account.shaba_number }}</template></td>
              <td style="color:#33a933"><template v-if="item.id">{{ formatPrice(item.amount) }} ریال</template></td>
            </tr>
            
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>جمع کل صورتحساب</td>
              <td>{{ getTotal }} ریال</td>
            </tr>
          </tbody>
        </table>
        
      </div>

      <div class="row my-3">
        <div class="col-6"></div>
        <div class="col-6">
          <div class="flex-1" style="font-size:.85em">

            <div class="col-6 bold-border p-1">قیمت لحظه ای تتر به ریال</div>
            <div class="col-6 bold-border p-1">
              {{ formatPrice(state_prices.sale_price * 10) }} ریال
            </div>

          </div>
        </div>
      </div>

      <div>* مشخصات واریز</div>

      <div class="thin-border">
        <table class="tbl">
          <thead>
            <tr>
              <th class="text-left">USDT</th>
              <th>(ارز دیجیتال)Coin</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-left">{{ form.wallet.address }}</td>
              <td>(آدرس ولت)Address Wallet</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-5">
        <div class="p-3">ملاحظات</div>
        <div style="font-size:.85em;padding: 0 .5rem;">
          <div>* عوارض قانونی درصورت تعلق به عهده مشتری است.</div>
          <div>* مسئولیت هرگونه اشتباه در ارسال آدرس بعهده مشتری است.</div>
          <div>* هر گونه مسئولیت استفاده و نگهداری و ذخیره ارز دیجیتال به عهده مشتری است.</div>
          <div>* در صورت سرمایه گذاری و استفاده  از ارز دیجیتال در سایتهای کلاهبرداری و شامل هرمی ، شرطبندی ، هر نوع پولشوئی و فیشینگ و یا ارسال به افراد مشکوک یا مجهول الهویه علاوه بر اینکه جرم تلقی می گردد ، تبعات آن به عهده مشتری است.</div>
          <div>* مسئولیت ارسال مشخصات بانکی مشتری برای افراد مجهول الهویه و مشکوک و همچنین در اختیار قرار دادن یا اجاره حساب بانکی و افراد دیگربه عهده مشتری است.</div>
          <div>* هر گونه نوسانات یا تغییرات قیمت با توجه به شرایط بازار بعهده مشتری است .</div>
          <div>* بعد از واریز و تائید این صورتحساب ، تسویه حساب نهایی بر اساس وضعیت قطعی تبادل خواهد بود .</div>
        </div>
      </div>

      <div class="mohr">
        <img :src="StaticImageUrl+'assets/images/mohr.jpg'">
      </div>

      <div class="">
        <img style="width:100%" :src="StaticImageUrl+'assets/images/prepay-footer.png'">
      </div>

    </div>

    <div class="font-titr" style="color: #ff8888;text-align: center;font-size: 1em;">
      بدون فیش واریزی و کد پیگیری بانکی این صورتحساب فاقد اعتبار عملیاتی است.
    </div>

  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
import Modal from '../../components/Modal.vue'
export default {
  name: 'PaymentAdvanceInvoice',
  components:{
    Sidebar,
    HelperNav,
    Modal,
    Header,
  },
  data : () => ({
    form:{
      admin_bank_account_id:null,
      wallet:null
    },
    amounts:[
      {
        user_bank_account:null,
        amount:null,
      }
    ],
    errors:{},
    admin_bank_account:{},
    admin_bank_accounts:[],
    deposit_details:[],
    pre_pay:false,
  }),
  computed:{
    getTotal(){
      let total = 0
      this.amounts.forEach(element => {
        if(element.amount){
          total += parseInt(element.amount);
        }
      });
      return this.formatPrice(total)
    }
  },
  methods:{
    getAdminAccount(){
      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()
      this.$axios.post(`getAdminAccount` , {},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.admin_bank_accounts = res.data.data
        this.admin_bank_account = {}
        this.activeLoading(false)
      })
      .catch(err => {
        this.errors = err.response.data.errors
        this.activeLoading(false)
      });

    },
    selectAdminBankAccount(){
      const bank_id = this.form.admin_bank_account_id;
      const bank = this.admin_bank_accounts.find(o => o.id === bank_id);

      this.admin_bank_account = bank;
    },
    addItem(){
      const item = {
        user_bank_account:null,
        amount:null
      }

      this.amounts.push(item);
      return true
    },
    removeItem(index){
      if(this.amounts.length === 1)
      {
        return false;
      }

      this.amounts.splice(index , 1)
      return true
    },
    prepareInvoice(){
      if(!this.admin_bank_account.id)
      {
        this.$notify({
          group: 'foo',
          type: 'error',
          duration: 4000,
          text: 'حساب بانکی ارزینه را انتخاب نمایید.'
        });
        return;
      }
      if(!this.form.wallet)
      {
        this.$notify({
          group: 'foo',
          type: 'error',
          duration: 4000,
          text: 'ولت خود را انتخاب نمایید.'
        });
        return;
      }

      let has_error = false;
      this.amounts.forEach(element => {
        if(!element.user_bank_account || !element.amount){
          has_error = true;
        }
      });

      if(has_error)
      {
        this.$notify({
          group: 'foo',
          type: 'error',
          duration: 4000,
          text: 'لطفا اطلاعات واریزی را تکمیل کنید.'
        });
        return;
      }

      
      let total = 0
      this.amounts.forEach(element => {
        if(element.amount){
          total += parseInt(element.amount);
        }
      });
      if(total < 2000000000)
      {
        this.$notify({
          group: 'foo',
          type: 'error',
          duration: 4000,
          text: 'حداقل مبلغ واریزی 200 میلیون تومان است.'
        });
        return;
      }

      for (let i = 0; i < 8 ; i++) {
        let item = {};
        if(this.amounts[i] !== undefined && this.amounts[i])
        {
          item.user_bank = this.amounts[i]['user_bank_account']
          item.amount = this.amounts[i]['amount']
          item.id = i + 1
          this.deposit_details.push(item)
        }else{
          this.deposit_details.push(item)
        }
      }
      
      this.pre_pay = true;

      setTimeout(() => {
        window.print()
      }, 1000);
    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()
    this.getAdminAccount()
  }
}
</script>
<style >
.prepay-header-logo{
  position: absolute;
  right: 0;
  top: 0;
  height: 120px;
}
.mohr{
  display: flex;
  justify-content: flex-end;
}
.mohr img{
  height: 90px;
  margin: 0 1em;
}
.holo{
  font-size: 2em;
    text-align: center;
    direction: ltr;
    font-family: monospace;
    color: #ff8888;
}
.prepay-wrapper{
  border: 5px solid rgba(249, 244, 255, 0.815);
  color: rgb(88, 88, 88);
  font-size: 14px;
  max-width: 1000px;
  margin: auto;
  position: relative;
}
.flex-1{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.w-50{
  width: 50%;
}
.bold-border{
  border: 2px solid rgb(41, 41, 41);
}
.thin-border{
  border: 1px solid rgb(41, 41, 41);
}
table.tbl{
  width: 100%;
  margin-bottom: 0;
}
table.tbl th ,
table.tbl td {
  border: 1px solid #000;
}
.tbl-wrapper{
  height: 243px;
  font-size: 1em;
}
@media (max-width: 900px) {
  .prepay-wrapper{
    font-size: 12px;
  }
  .tbl-wrapper{
    height: 213px;
  }
}
@media (max-width: 700px) {
  .prepay-wrapper{
    font-size: 11px;
  }
  .tbl-wrapper{
    height: 198px;
  }
}
@media (max-width: 500px) {
  .prepay-wrapper{
    font-size: 9px;
  }
  .tbl-wrapper{
    height: 168px;
  }
  .prepay-header-logo{
    height: 70px;
  }
  .mohr img{
    height: 60px;
  }
}
@media (max-width: 400px) {
  .prepay-wrapper{
    font-size: 7px;
  }
  .tbl-wrapper{
    height: 138px;
  }
}
@media (max-width: 350px) {
  .prepay-wrapper{
    font-size: 6px;
  }
  .tbl-wrapper{
    height: 122px;
  }
  .prepay-header-logo{
    height: 50px;
  }
  .mohr img{
    height: 40px;
  }
}
</style>